import { render } from "./datasetDetails.vue?vue&type=template&id=3bbc79e8"
import script from "./datasetDetails.vue?vue&type=script&lang=js"
export * from "./datasetDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__